__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/2a97a88/packs/";